export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/logo.svg?dfa25b22cdb9dbcf50ce8101e13fb686";